import type { ReactElement } from "react";
import { simplybusinessUkAmbles } from "./simplybusiness-uk";
import { simplybusinessUsAmbles } from "./simplybusiness-us";
import { siteAmbles } from "./sites";

export type AmbleContent = string | ReactElement;

export type Ambles = {
  siteAmbles: Record<string, Record<string, AmbleContent>>;
  simplybusinessUkAmbles: Record<string, AmbleContent>;
  simplybusinessUsAmbles: Record<string, AmbleContent>;
};

/**
 * Amble registry organized by priority: sites, then locale-specific.
 * Used by getAmble for the lookup cascade.
 */
export const ambles: Ambles = {
  siteAmbles,
  simplybusinessUkAmbles,
  simplybusinessUsAmbles,
};
